(function () {
  'use strict';

  // Mobile nav
  var toggle = document.querySelector('.site-header__hamburger');
  var drawer = document.querySelector('.mobile-nav');
  if (toggle && drawer) {
    toggle.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  // Reading progress
  var bar = document.querySelector('.reading-progress');
  if (bar) {
    window.addEventListener('scroll', function () {
      var d = document.documentElement;
      bar.style.width = Math.min((d.scrollTop / (d.scrollHeight - d.clientHeight)) * 100, 100) + '%';
    }, { passive: true });
  }

  // Country filter (client-side, for tagged pages already loaded)
  var pills = document.querySelectorAll('.country-pill[data-tag]');
  var cards = document.querySelectorAll('.post-card[data-tags]');
  if (pills.length && cards.length) {
    pills.forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        e.preventDefault();
        pills.forEach(function (p) { p.classList.remove('country-pill--active'); });
        pill.classList.add('country-pill--active');
        var tag = pill.dataset.tag;
        cards.forEach(function (card) {
          if (tag === 'all') {
            card.style.display = '';
          } else {
            var tags = (card.dataset.tags || '').split(',').map(function (t) { return t.trim().toLowerCase(); });
            card.style.display = tags.includes(tag.toLowerCase()) ? '' : 'none';
          }
        });
      });
    });
  }

}());
